<template>
  <div>
    <ListPage title="Campaigns" :headers="headers" :items="channels.items"
        :cols="4"
    >
      <template v-slot:actions>
        <v-btn text color="primary" @click="() => (newDialog = !newDialog)"
          ><v-icon>mdi-plus</v-icon> Add New
        </v-btn>
      </template>
      <template v-slot:card="{ item }">
        <ChannelCardItem
          :value="item"
          @onDetails="onDetails"
        ></ChannelCardItem>
      </template>

      <template v-slot:row="{ item, headers }">
        <ChannelTableItem :value="item" :headers="headers"></ChannelTableItem>
      </template>
    </ListPage>
    <!-- <NewInventoryItemDialog
      v-model="newInventoryItemDialog"
    ></NewInventoryItemDialog> -->
  </div>
</template>
  
  <script>
import ListPage from "../../../components/organisms/layout/ListPage.vue";
// import NewInventoryItemDialog from "./components/NewInventoryItemDialog.vue";
import ChannelCardItem from "../../../components/organisms/channel/ChannelCardItem.vue";
import ChannelTableItem from "../../../components/organisms/channel/ChannelTableItem.vue";
import { ChannelAPIInstance } from "../../../api";

export default {
  data() {
    return {
      newDialog: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Status", value: "status" },
        { text: "Name", value: "name" },
        { text: "Code", value: "code" },
        { text: "Description", value: "description" },
        { text: "Created", value: "created_at" },
      ],
      channels: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
    };
  },
  computed: {},
  components: {
    ChannelCardItem,
    ChannelTableItem,
    ListPage,
    // NewInventoryItemDialog,
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { items, pagination } = await ChannelAPIInstance.list(
        this.channels.pagination
      );

      this.channels.items = items;
      this.channels.pagination = pagination;
    },

    onDetails(inventoryItem) {
      this.$router.push(`/campaigns/${inventoryItem.id}`, {
        params: { id: inventoryItem.id },
      });
    },
    onCreate(type) {
      this.$router.push(`/new-inventoryItem/${type.id}`);
    },
  },

  watch: {},
};
</script>
  
  
  <style lang="scss" scoped>
</style>